// 9fbef606107a605d69c0edbcd8029e5d
import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import checkoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import PickupLocation from './PickupLocation.view';

function PickupCollapsed(props) {
  const {
    pickUpAlternatePerson,
    pickUpContactPerson,
    isLoginV2FlowEnabled,
    shipments,
    bossSwitchEnabled,
    isNewEddViewCheckout,
    isInternationalPhoneNumberEnabled,
  } = props;
  const checkoutPickupLabels = getLabelFromCopyOrFromTranslation('checkout.pickup', checkoutLabels);
  const countryDialCode =
    isInternationalPhoneNumberEnabled &&
    pickUpContactPerson?.phoneCountryCode &&
    pickUpContactPerson?.phoneCountryCode !== '+1'
      ? `${pickUpContactPerson?.phoneCountryCode} ${pickUpContactPerson?.phoneNumber}`
      : pickUpContactPerson?.phoneNumber;
  return (
    <>
      {!isEmpty(pickUpContactPerson?.firstName) && !isEmpty(pickUpContactPerson?.lastName) && (
        <BodyCopy component="div" className="spc-card-content">
          <BodyCopy
            component="div"
            fontFamily="secondary"
            fontWeight="bold"
            fontSize="fs18"
            className="elem-mb-XXS spc-card-content-fields"
          >
            {renderLabel(checkoutPickupLabels.lbl_pickup_contact_title, 'lbl_pickup_contact_title')}
          </BodyCopy>
          <BodyCopy
            component="div"
            fontFamily="secondary"
            fontSize="fs16"
            className="elem-mb-XXS spc-card-content-fields"
          >
            {`${pickUpContactPerson?.firstName} ${pickUpContactPerson?.lastName}`}
          </BodyCopy>
          {isLoginV2FlowEnabled && !isEmpty(pickUpContactPerson?.phoneNumber) && (
            <BodyCopy
              component="div"
              fontFamily="secondary"
              fontSize="fs16"
              className="elem-mb-XXS spc-card-content-fields"
            >
              {countryDialCode}
            </BodyCopy>
          )}
          {!isEmpty(pickUpAlternatePerson?.firstName) && !isEmpty(pickUpAlternatePerson?.lastName) && (
            <>
              <BodyCopy
                component="div"
                fontFamily="secondary"
                fontWeight="bold"
                fontSize="fs18"
                className="elem-mb-XXS elem-mt-LRG spc-card-content-fields"
              >
                {renderLabel(
                  checkoutPickupLabels.lbl_alternate_pickup_contact_title,
                  'lbl_alternate_pickup_contact_title'
                )}
              </BodyCopy>
              <BodyCopy
                component="div"
                fontFamily="secondary"
                fontSize="fs16"
                className="elem-mb-XXS spc-card-content-fields"
              >
                {`${pickUpAlternatePerson?.firstName} ${pickUpAlternatePerson?.lastName}`}
              </BodyCopy>
              <BodyCopy
                component="div"
                fontFamily="secondary"
                fontSize="fs16"
                className="elem-mb-XXS spc-card-content-fields"
              >
                {pickUpAlternatePerson?.emailAddress}
              </BodyCopy>
            </>
          )}
          {(bossSwitchEnabled || isNewEddViewCheckout) && (
            <PickupLocation shipments={shipments} {...props} />
          )}
        </BodyCopy>
      )}
    </>
  );
}

PickupCollapsed.propTypes = {
  pickUpAlternatePerson: PropTypes.shape({}),
  pickUpContactPerson: PropTypes.shape({}),
  spcLabels: PropTypes.shape({}).isRequired,
  isLoginV2FlowEnabled: PropTypes.bool,
};

PickupCollapsed.defaultProps = {
  isLoginV2FlowEnabled: false,
};

export default errorBoundary(PickupCollapsed);
